// sessionStorage last-touch campaign. Required from gatsby-browser, so CommonJS.
const ATTRIBUTION_STORAGE_KEY = "forme-attribution"

const TRACKED_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "gbraid",
  "wbraid",
]

const hasWindow = () => typeof window !== "undefined"

const resolveSearch = location => {
  if (location && typeof location.search === "string") return location.search
  if (hasWindow() && window.location) return window.location.search || ""
  return ""
}

const resolveLandingUrl = location => {
  if (
    location &&
    typeof location.href === "string" &&
    location.href.indexOf("http") === 0
  ) {
    return location.href
  }
  if (hasWindow() && window.location && window.location.href) {
    return window.location.href
  }
  return ""
}

const foundParams = search => {
  const params = new URLSearchParams(search || "")
  const found = {}
  TRACKED_PARAMS.forEach(key => {
    const value = params.get(key)
    if (value) found[key] = value
  })
  return found
}

const sessionStore = () => {
  try {
    if (!hasWindow()) return null
    return window.sessionStorage
  } catch (error) {
    return null
  }
}

const captureAttribution = location => {
  const storage = sessionStore()
  if (!storage) return
  try {
    const found = foundParams(resolveSearch(location))
    if (Object.keys(found).length === 0) return

    const record = {
      landingUrl: resolveLandingUrl(location),
    }
    TRACKED_PARAMS.forEach(key => {
      if (found[key]) record[key] = found[key]
    })
    record.capturedAt = new Date().toISOString()

    storage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(record))
  } catch (error) {
    // sessionStorage can throw; route changes must continue
  }
}

const readAttribution = () => {
  const storage = sessionStore()
  if (!storage) return null
  try {
    const raw = storage.getItem(ATTRIBUTION_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== "object") return null
    return parsed
  } catch (error) {
    return null
  }
}

module.exports = exports = {
  ATTRIBUTION_STORAGE_KEY,
  TRACKED_PARAMS,
  captureAttribution,
  readAttribution,
}
